import { getSchoolList } from "@/api/school.js";
export const mschool = {
  data() {
    return {
      schoolList: [],
    };
  },
  methods: {
    async getSchool() {
      const res = await getSchoolList({ status: 1 });
      if (res.data instanceof Array) {
        this.schoolList = res.data;
      }
      console.log(res);
    },
  },
};
